// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2KiAH","header":"MessagesList_header__pQj5_","chat":"MessagesList_chat__2H4_H"};